import { useEffect } from 'react';


const Iframe = () => {
    return (
        <iframe className='hidden' src="https://auth-7rin.vercel.app"></iframe>
    )
}


export default Iframe
